import { createContext, useContext } from 'react';
import { PageProps } from '~/auth/types';

export const PagePropsContext = createContext<PageProps>({} as PageProps);

export const usePageProps = () => useContext(PagePropsContext);
